export default __webpack_public_path__ + "static/media/error.2aa237a4.svg";